const getters = {
  token: state => state.user.token,
  userId: state => state.user.userId,
  openId: state => state.user.openId,
  nickName: state => state.user.nickName,
  fullName: state => state.user.fullName,
  headImage: state => state.user.headImage,
  mobile: state => state.user.mobile,
  roleId: state => state.user.roleId,
  introduceCode: state => state.user.introduceCode,
  couponCode: state => state.user.couponCode,
  defaultRole: state => state.user.defaultRole,
  meState: state => state.user.meState, 
  hrName: state => state.user.hrName,
  hrState: state => state.user.hrState,
  gw_mobile: state => state.user.mobile
};
export default getters;